import { Map } from 'immutable';

import * as SpecialOffersConstants from './constants';

export function getSpecialOfferProduct(specialOfferProductGroups) {
  if (specialOfferProductGroups && specialOfferProductGroups.size) {
    return specialOfferProductGroups.get(0);
  }
}

export function getSpecialOfferProductGroupByProvider(paymentProvider) {
  return specialOfferProductGroups => {
    let result = Map();
    if (specialOfferProductGroups) {
      result = specialOfferProductGroups.find(group => {
        return group.get(SpecialOffersConstants.PAYMENT_PROVIDER) === paymentProvider;
      });
    }
    return result;
  };
}

export function isPathInRedeemFlow(pathname) {
  let match;
  if (pathname) {
    match = ['/settings/info', '/settings/redeem', '/offer', '/account', '/payment', 'paypal'].find(
      redeemPath => {
        if (pathname.includes(redeemPath)) {
          return redeemPath;
        }
      },
    );
  }
  return !!match;
}
